/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table.weekday-meta[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding-right:1em;text-align:left;line-height:.8em;border-left:1px solid #d3d3d3}table.weekday-meta[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type{border-left:none}table.weekday-meta[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-size:8pt}fieldset[_ngcontent-%COMP%]{border:1px solid #d3d3d3}"];
export { styles as styles };
